
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { setIsAnyHovered, setHoveredColor } from '../pages/slices/floatDotSlicer';
import './FloatingDot.css';

const FloatingDot = ({ color, message, author }) => {
  const dispatch = useDispatch();    

  const [isHovered, setIsHovered] = useState(false);
  const [dotPosition, setDotPosition] = useState({ top: window.innerHeight/2 + 'px', left: window.innerWidth/2 + 'px' });
  const dotRef = useRef(null);
  const [randomKeyframes, setRandomKeyframes] = useState('');
  const [animationName, setAnimationName] = useState('');

  useEffect(() => {
    const randomizePosition = () => {
      // Screen center
      const screenCenterX = window.innerWidth / 2;
      const screenCenterY = window.innerHeight / 2;

      // Centralized area dimensions (1300px by 700px)
      const areaWidth = 1300;
      const areaHeight = 700;

      // Reserved area dimensions (600px by 200px)
      const reservedWidth = 600;
      const reservedHeight = 200;

      // Calculate the boundaries for the allowed area
      const allowedLeft = screenCenterX - areaWidth / 2;
      const allowedTop = screenCenterY - areaHeight / 2;

      // Calculate the reserved area position
      const reservedLeft = screenCenterX - reservedWidth / 2;
      const reservedTop = screenCenterY - reservedHeight / 2;
      const reservedRight = reservedLeft + reservedWidth;
      const reservedBottom = reservedTop + reservedHeight;

      let top, left;

      // Generate random positions until they are outside the reserved area
      do {
        top = allowedTop + Math.random() * (areaHeight - 20); // Subtract 20px to keep the dot fully inside the allowed area
        left = allowedLeft + Math.random() * (areaWidth - 20);
      } while (
        top > reservedTop && top < reservedBottom &&
        left > reservedLeft && left < reservedRight
      );

      setDotPosition({ top: `${top}px`, left: `${left}px` });
    };

    randomizePosition();

    const uniqueName = `gentleFloat_${Math.random().toString(36).substr(2, 9)}`;
    setAnimationName(uniqueName);

    const generateRandomKeyframes = () => {
      const x1 = Math.random() * 20 - 10;
      const y1 = Math.random() * 20 - 10;
      const x2 = Math.random() * 20 - 10;
      const y2 = Math.random() * 20 - 10;

      return `
        @keyframes ${uniqueName} {
          0% {
            transform: translate(0px, 0px);
          }
          50% {
            transform: translate(${x1}px, ${y1}px);
          }
          100% {
            transform: translate(${x2}px, ${y2}px);
          }
        }
      `;
    };

    setRandomKeyframes(generateRandomKeyframes());

  }, []);

  useEffect(() => {
    if (dotRef.current) {
      dotRef.current.style.backgroundColor = isHovered ? 'transparent' : color;
      dotRef.current.style.width = isHovered ? '250px' : '20px';
      dotRef.current.style.height = isHovered ? '1px' : '20px';
      dotRef.current.style.borderRadius = isHovered ? '5%' : '50%';
      dotRef.current.style.cursor = isHovered ? 'none' : 'pointer';
      dotRef.current.style.display = 'flex';
      dotRef.current.style.alignItems = 'center';
      dotRef.current.style.justifyContent = 'center';
      dotRef.current.style.animationName = animationName;
      dotRef.current.style.filter = isHovered ? 'blur(0px)' : 'blur(10px)';
    }

    if(isHovered){
      dispatch(setHoveredColor(color));
    }

  }, [isHovered, color, animationName, dispatch]);

  const handleMouseEnter = () => {
    setIsHovered(true);
    dispatch(setIsAnyHovered(true));
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    dispatch(setIsAnyHovered(false));
  };

  return (
    <div>
      <style>{randomKeyframes}</style>
      <div
        className="floating-dot"
        ref={dotRef}
        style={dotPosition}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {isHovered && 
        <div className="quote-container">
          <div className="message">"{message}"</div>
          <div className="author">{author}</div>
        </div>
        }
      </div>
    </div>
  );
};

export default FloatingDot;